import React from 'react';
import * as PropTypes from 'prop-types';
import TextField from '../../../../components/TextField';
import { connect } from 'react-redux';
import { showMessage } from '../../../../actions/snackbar';
import { setChannelContractDisplayName } from '../../../../actions/channelContract';

const DisplayNameTextField = (props) => {
    const onChange = (newValue) => {
        const allowedRegex = /^[a-zA-Z0-9 !@#$%&*()_\-=+~.,:;'"?/|\\^]*$/;

        if (!allowedRegex.test(newValue)) {
            props.showMessage('Only letters, numbers, spaces, and common special characters are allowed');
            return;
        }

        props.onChange(newValue);
    };

    return (
        <TextField
            id="channelDisplayName"
            name="channelDisplayName"
            placeholder="Enter Display Name"
            value={props.value}
            variant="outlined"
            onChange={onChange}/>
    );
};

DisplayNameTextField.propTypes = {
    address: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    showMessage: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        value: state.channelContract.channelContractDisplayName,
        address: state.account.connection.address,
    };
};

const actionToProps = {
    onChange: setChannelContractDisplayName,
    showMessage,
};

export default connect(stateToProps, actionToProps)(DisplayNameTextField);
